import { observable } from 'mobx'

class Auth {
  @observable store = {
    // 用户信息
    info: {
      username: '',
      token: '',
      type: 0,
      company: ''
    }
  }

  setUserInfo (username, token, type, company) {
    this.store.info.username = username
    this.store.info.token = token
    this.store.info.type = parseInt(type)
    this.store.info.company = company

    this.storage()
  }
  storage () {
    window.localStorage.setItem('username', this.store.info.username)
    window.localStorage.setItem('token', this.store.info.token)
    window.localStorage.setItem('type', this.store.info.type)
    window.localStorage.setItem('company', this.store.info.company)
  }
}

export default
new Auth()



// WEBPACK FOOTER //
// ./src/store/modules/auth.js